import { create } from 'zustand'
import { api } from '@/lib/api'

interface DashboardStats {
  totalUsers: number
  activeUsers7d: number
  waitlist: Record<string, number>
  creditsUsed30d: number
  apiRequests30d: number
  recentSignups: Array<{
    id: string
    email: string
    name: string
    createdAt: string
  }>
}

interface ChartData {
  registrations: Array<{ date: string; count: number }>
  credits: Array<{ date: string; actionType: string; total: string }>
  requests: Array<{ date: string; count: number }>
}

interface DashboardState {
  stats: DashboardStats | null
  charts: ChartData | null
  isLoading: boolean
  error: string | null
  fetchStats: () => Promise<void>
  fetchCharts: () => Promise<void>
}

export const useDashboardStore = create<DashboardState>((set) => ({
  stats: null,
  charts: null,
  isLoading: false,
  error: null,

  fetchStats: async () => {
    set({ isLoading: true, error: null })
    try {
      const res = await api.get<{ data: DashboardStats }>('/api/v1/admin/dashboard')
      set({ stats: res.data, isLoading: false })
    } catch (err) {
      set({ error: (err as Error).message, isLoading: false })
    }
  },

  fetchCharts: async () => {
    try {
      const res = await api.get<{ data: ChartData }>('/api/v1/admin/dashboard/charts')
      set({ charts: res.data })
    } catch (err) {
      console.error('Failed to fetch chart data:', err)
    }
  },
}))
